import type { Page } from '@/domain/model/Page';
import type { ListCurriculumsQuery } from '@/application/port/in/dto/CurriculumCommand';
import type {
  ArchiveCurriculumUseCase,
  CreateCurriculumUseCase,
  GetCurriculumUseCase,
  ListCurriculumsByCourseFullUseCase,
  PublishCurriculumUseCase,
  UpdateCurriculumUseCase,
} from '@/application/port/in/CurriculumUseCase';
import type {
  CreateCurriculumCommand,
  UpdateCurriculumCommand,
} from '@/application/port/in/dto/CurriculumCommand';
import type { CurriculumGateway } from '@/application/port/out/CurriculumGateway';
import type { Curriculum } from '@/domain/model/Curriculum';

export class ListCurriculumsByCourseFullUseCaseImpl
  implements ListCurriculumsByCourseFullUseCase
{
  constructor(private readonly gateway: CurriculumGateway) {}
  execute(courseId: string): Promise<Curriculum[]> {
    if (!courseId) return Promise.resolve([]);
    return this.gateway.listByCourse(courseId);
  }
}

export class GetCurriculumUseCaseImpl implements GetCurriculumUseCase {
  constructor(private readonly gateway: CurriculumGateway) {}
  execute(id: string): Promise<Curriculum> {
    if (!id) return Promise.reject(new Error('ID da matriz é obrigatório'));
    return this.gateway.getById(id);
  }
}

export class CreateCurriculumUseCaseImpl implements CreateCurriculumUseCase {
  constructor(private readonly gateway: CurriculumGateway) {}
  execute(command: CreateCurriculumCommand): Promise<Curriculum> {
    return this.gateway.create(command);
  }
}

export class UpdateCurriculumUseCaseImpl implements UpdateCurriculumUseCase {
  constructor(private readonly gateway: CurriculumGateway) {}
  execute(id: string, command: UpdateCurriculumCommand): Promise<Curriculum> {
    return this.gateway.update(id, command);
  }
}

export class PublishCurriculumUseCaseImpl implements PublishCurriculumUseCase {
  constructor(private readonly gateway: CurriculumGateway) {}
  execute(id: string): Promise<Curriculum> {
    return this.gateway.publish(id);
  }
}

export class ArchiveCurriculumUseCaseImpl implements ArchiveCurriculumUseCase {
  constructor(private readonly gateway: CurriculumGateway) {}
  execute(id: string): Promise<Curriculum> {
    return this.gateway.archive(id);
  }
}

export class ListCurriculumsUseCaseImpl {
  constructor(private readonly gateway: CurriculumGateway) {}
  execute(query: ListCurriculumsQuery): Promise<Page<Curriculum>> { return this.gateway.list(query); }
}
